// Supabase auth-storage helpers that do NOT import @supabase/supabase-js.
//
// main.tsx runs the pre-mount legacy-token purge on every load. Keeping these
// helpers SDK-free lets the entry bundle call the purge without pulling the
// whole Supabase SDK into first paint — the SDK now loads only on the lazy
// /auth/* routes that actually sign users in.

export const SUPABASE_BROWSER_STORAGE_KEY = 'aircs-supabase-auth-session';

export function isSupabaseAuthStorageKey(key: string): boolean {
  return key === SUPABASE_BROWSER_STORAGE_KEY
    || key.startsWith(`${SUPABASE_BROWSER_STORAGE_KEY}-`)
    || /^sb-.+-auth-token(?:$|-)/.test(key);
}

export function removeSupabaseStorage(storage: Storage | undefined): void {
  if (!storage) return;
  try {
    const keys = Array.from({ length: storage.length }, (_, index) => storage.key(index)).filter(Boolean) as string[];
    keys
      .filter(isSupabaseAuthStorageKey)
      .forEach((key) => storage.removeItem(key));
  } catch {
    // Storage can be disabled by the browser. The Business OS cookie is still
    // authoritative and sessionStorage remains tab-scoped when available.
  }
}

/**
 * Remove auth material left by the former localStorage-backed Supabase client.
 * This runs before React mounts, not only after a successful callback, so a
 * stale token is removed even when the user never completes another login.
 */
export function purgeLegacySupabaseLocalStorage(
  storage: Storage | undefined = typeof window === 'undefined' ? undefined : window.localStorage,
): void {
  removeSupabaseStorage(storage);
}
